import React, { useEffect } from 'react'
import { SelectInput, TextInput } from '@demandlocal/components'
import { useFormContext, useWatch } from 'react-hook-form'
import { Option } from '../../../lib/types/Option'

export default function EditUserInfo({
  rolesOptions,
}: {
  rolesOptions: Option[]
}): JSX.Element {
  const { control, trigger } = useFormContext()
  const newPasswordConfirmation = useWatch({
    control,
    name: 'confirm_password',
  })

  const newPassword = useWatch({
    control,
    name: 'new_password',
  })

  const email = useWatch({
    control,
    name: 'email',
  })

  useEffect(() => {
    if (newPasswordConfirmation?.length > 0 && newPassword?.length > 0) {
      trigger('new_password')
      trigger('confirm_password')
    }
  }, [newPassword, newPasswordConfirmation, trigger])

  useEffect(() => {
    if (email?.length > 0) trigger('email')
  }, [email, trigger])

  return (
    <div>
      <div className={'pt-6 pb-6 border-b-2 flex flex-col'}>
        <div className={'flex flex-row gap-8 w-full'}>
          <div className={'w-1/2'}>
            <TextInput
              rules={{ required: 'This field is required' }}
              inverted
              name={'first_name'}
              label={'First name'}
            />
          </div>
          <div className={'w-1/2'}>
            <TextInput
              rules={{ required: 'This field is required' }}
              inverted
              name={'last_name'}
              label={'Last name'}
            />
          </div>
        </div>
      </div>
      <div className={'pt-6 pb-6 border-b-2 flex flex-col'}>
        <div className={'pt-4 flex flex-row gap-8'}>
          <div className={'w-1/2'}>
            <TextInput
              rules={{
                required: 'This field is required',
                validate: {
                  noWhiteSpace: (value) => {
                    return value.length > 0 && value.match(/[^\S]/)
                      ? 'Email must not contain whitespace'
                      : true
                  },
                },
              }}
              inverted
              name={'email'}
              label={'Email'}
            />
          </div>
          <div className={'w-1/2'}>
            <SelectInput
              rules={{ required: 'This field is required' }}
              name={'role_id'}
              label={'Role'}
              options={rolesOptions}
            />
          </div>
        </div>
      </div>
      <div className={`pt-10 flex flex-col gap-5`}>
        <span className={'font-bold text-base'}>Password</span>
        <div className={'w-1/2'}>
          <TextInput
            type={'password'}
            inverted
            rules={{
              validate: {
                passwordsMatch: (value) => {
                  return newPasswordConfirmation?.length > 0
                    ? value === newPasswordConfirmation || 'Passwords do not match'
                    : true
                },
                securePassword: (value) => {
                  // is at least 8 characters long & contains at least one number & one letter & one special character
                  return (!value && !newPasswordConfirmation) ||
                    (value.length >= 8 &&
                      value.match(/[a-z]/) &&
                      value.match(/[A-Z]/) &&
                      value.match(/[0-9]/) &&
                      value.match(/[^a-zA-Z0-9]/))
                    ? true
                    : 'Password must be at least 8 characters long and contain at least one number, one uppercase letter, and one special character'
                },
              },
            }}
            name={'new_password'}
            label={'New password'}
            control={control}
          />
        </div>
        <div className={'w-1/2'}>
          <TextInput
            type={'password'}
            inverted
            rules={{
              validate: (value) => {
                return value === newPassword || 'Passwords do not match'
              },
            }}
            name={'confirm_password'}
            label={'Confirm password'}
            control={control}
          />
        </div>
      </div>
    </div>
  )
}
